import { Stack, Typography } from "@mui/material";
import {
  isLegendSymbolizerLine,
  isLegendSymbolizerPoint,
  isLegendSymbolizerPolygon,
  isLegendSymbolizerRaster,
  isLegendSymbolizerRasterInterval,
  isLegendSymbolizerRasterRamp,
  isLegendSymbolizerRasterValues,
  LegendSymbolizer,
  LegendSymbolizerRaster,
} from "../../hooks/legendHooks";
import { LegendSymbolizerItemLine } from "./LegendSymbolizerItemLine";
import { LegendSymbolizerItemPoint } from "./LegendSymbolizerItemPoint";
import { LegendSymbolizerItemPolygon } from "./LegendSymbolizerItemPolygon";
import { LegendSymbolizerItemRaster } from "./LegendSymbolizerItemRaster";
import { LegendSymbolizerItemRasterInterval } from "./LegendSymbolizerItemRasterInterval";
import { LegendSymbolizerItemRasterRamp } from "./LegendSymbolizerItemRasterRamp";
import { LegendSymbolizerItemRasterValues } from "./LegendSymbolizerItemRasterValues";

interface Props {
  title: string;
  symbolizer: LegendSymbolizer;
}

export function LegendSymbolizerItem(props: Props) {
  const { title, symbolizer } = props;

  function renderRasterSymbolizer(symbolizer: LegendSymbolizerRaster) {
    if (isLegendSymbolizerRasterRamp(symbolizer))
      return <LegendSymbolizerItemRasterRamp symbolizer={symbolizer} />;
    else if (isLegendSymbolizerRasterValues(symbolizer))
      return <LegendSymbolizerItemRasterValues symbolizer={symbolizer} />;
    else if (isLegendSymbolizerRasterInterval(symbolizer))
      return <LegendSymbolizerItemRasterInterval symbolizer={symbolizer} />;
    return <LegendSymbolizerItemRaster symbolizer={symbolizer} />;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {isLegendSymbolizerPolygon(symbolizer) && (
        <LegendSymbolizerItemPolygon symbolizer={symbolizer} />
      )}
      {isLegendSymbolizerRaster(symbolizer) &&
        renderRasterSymbolizer(symbolizer)}
      {isLegendSymbolizerLine(symbolizer) && (
        <LegendSymbolizerItemLine symbolizer={symbolizer} />
      )}
      {isLegendSymbolizerPoint(symbolizer) && (
        <LegendSymbolizerItemPoint symbolizer={symbolizer} />
      )}
      {title && (
        <Typography sx={{ display: "flex", flexDirection: "column" }}>
          {title.split("\n").map((part, i) => (
            <span key={`${i}-${part}`}>{part}</span>
          ))}
        </Typography>
      )}
    </Stack>
  );
}
